<template>
  <div>
    <label v-if="label" class="jm-mb-2" data-test="select-label">{{
      label
    }}</label>
    <select
      :value="modelValue"
      class="jm-p-2"
      @change="$emit('update:modelValue', $event.target.value)"
      data-test="select-element"
    >
      <option
        v-for="option in options"
        :value="option.value"
        :key="option.value"
        :selected="option === modelValue"
        data-test="select-option"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, Number],
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
label,
select {
  display: block;
}

select {
  box-sizing: border-box;
  width: 100%;
  border: $border-width-sm solid $border-color-input;
  border-radius: $border-radius-base;
  background-color: $white;
}
</style>
